module.exports = __webpack_public_path__ + "static/media/filter-sliders-icon.f89fe3c4.svg";